import { manutencao_de_equivalencia_de_ensinos_para_historia } from "./manutencao-de-equivalencia-de-ensinos-para-historia";
import { manutencao_equivalencia_estudos } from "./manutencao-equivalencia-estudos";
import { manutencao_estudo_sem_escolaridade } from "./manutencao-estudo-sem-escolaridade";

const parametros_de_escolaridade = [
  manutencao_de_equivalencia_de_ensinos_para_historia,
  manutencao_equivalencia_estudos,
  manutencao_estudo_sem_escolaridade,
];

export { parametros_de_escolaridade };
